const convertCurrency = (amount, from, to) => {
	if (window.kopy_disableCurrencyConversion) return amount
	if (from === to) return amount
	if (typeof window.Currency === "undefined") return amount
	if (!from || !to) return amount

	let price = amount
	try {
		price = window.Currency.convert(amount, from, to)
		return price
	} catch (error) {
		console.error("convertCurrency catched error", error)
		return amount
	}
}

export default convertCurrency
